/**
 * Shared UI motion presets for overlays, sheets, and list surfaces.
 * Kept separate from {@link DYNAMIC_ISLAND} so general UI can evolve independently.
 */
export const UI_MOTION = {
    /** Master switch — false keeps instant mount/unmount (pre-Motion behavior). */
    "enabled": true,

    "spring": {
        /** Default spring aligned with Dynamic Island chrome. */
        "default": {
            "type":      "spring" as const,
            "stiffness": 420,
            "damping":   32,
            "mass":      0.8,
        },

        /** Softer spring for bottom sheets and list surfaces. */
        "gentle": {
            "type":      "spring" as const,
            "stiffness": 380,
            "damping":   34,
            "mass":      0.85,
        },

        /** Slower spring for the itinerary itinerary panel bottom sheet. */
        "sheet": {
            "type":      "spring" as const,
            "stiffness": 240,
            "damping":   36,
            "mass":      1.1,
        },
    },

    "duration": {
        /** Fast dismiss / micro transitions (ms). */
        "fastMs": 220,

        /** Bottom sheet and modal card shell (ms). */
        "sheetMs": 320,

        /** Itinerary panel dismiss when spring exit is not used (ms). */
        "itineraryPanelSheetMs": 520,

        /** Stop popup row exit when a vehicle departs and drops off the list (ms). */
        "stopPopupDepartureExitMs": 420,
    },

    /** Per-item stagger delay for list reveals (ms). */
    "staggerItemMs": 45,

    /** Stagger delay for itinerary panel itinerary rows after search completes (ms). */
    "itineraryPanelStaggerItemMs": 60,

    /** Delay between TravelProgress leg strips within one itinerary row (ms). */
    "itineraryPanelProgressSegmentStaggerMs": 70,

    /** Extra delay before the first leg strip of each itinerary row (ms). */
    "itineraryPanelProgressRowOffsetMs": 40,

    /** Extra delay after list items before trailing rows (ms). */
    "staggerTrailingMs": 80,

    /** Saved-itinerary accordion/section row reveal duration (ms). */
    "savedListTemporalEnterMs": 520,

    /** Saved-itinerary accordion/section row hide duration (ms). */
    "savedListTemporalExitMs": 420,

    /** Stagger between rows when a saved-list section expands (ms). */
    "savedListTemporalStaggerMs": 110,

    /** iOS-like cubic-bezier shared with MiniModal. */
    "easingIos": [ 0.2, 0.8, 0.2, 1 ] as const,
} as const;
